module.exports = __webpack_public_path__ + "img/img24.362ddca8.png";